import { StyledButton } from "./styles"
import { Box, Typography } from "@mui/material"
import React, { useCallback, useEffect } from "react"
import { ButtonProps } from "./types"
import { generatePath, useHistory } from "react-router-dom"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner"
// import Image from "../Image"
// import { default as barcode } from "../../assets/icons/Barcode.svg"
// import { default as barcode_conti } from "../../assets/icons/Barcode_conti.svg"
import { default as general_eancode_image } from "../../assets/images/general_eancode.png"
// import { default as general_eancode_image_ate } from "../../assets/images/general_eancode_ate.png"
import {
  contiEanCode,
  barcodeIconBase64,
  ateEanCode,
  isAte,
  isConti,
} from "utils/Global"
import { StyledBox, StyledImage } from "components/Image/styles"

const Button: React.FC<ButtonProps> = (props) => {
  const {
    hidden,
    text,
    path,
    isDisabled,
    type,
    onClick,
    isForwardIcon,
    isScannIcon,
    isBarcode,
    isOvverride,
    isFlexFlow,
    width,
  } = props
  const history = useHistory()

  const [eanCodeImg, setEanCodeImg] = React.useState(contiEanCode)

  useEffect(() => {
    if (isAte) {
      setEanCodeImg(ateEanCode)
    } else if (isConti) {
      setEanCodeImg(contiEanCode)
    } else {
      setEanCodeImg(contiEanCode)
    }
  }, [])

  const handleClick = useCallback(() => {
    if (isDisabled || type !== undefined) {
      return
    } else if (path.includes("http")) {
      const win = window.open(path, "_blank")
      if (win != null) {
        win.focus()
      }
    } else if (path?.length > 0) {
      const currentPath = history.location.pathname
      history.push({
        pathname: generatePath(path),
        previous: currentPath,
      })
    }
  }, [history, path, isDisabled, type])

  const isOnClickOvverride = useCallback(() => {
    if (isDisabled || type !== undefined) {
      return
    } else if (path.includes("http")) {
      const win = window.open(path, "_blank")
      if (win != null) {
        win.focus()
      }
    } else if (path?.length > 0) {
      const currentPath = history.location.pathname
      sessionStorage.setItem("imageVas", general_eancode_image)
      history.push({
        pathname: generatePath(path),
        previous: currentPath,
      })
    }
  }, [history, path, isDisabled, type])

  const checkProps = () => {
    const scrollAnchor = document.getElementById("scroll_anchor")
    const osTitleBar = document.getElementById("os-title-bar") as HTMLElement

    let topPos = 0
    let titleTop = 0

    // if (osTitleBar) {
    //   const titleheight = osTitleBar.getBoundingClientRect().height
    //   topPos = titleheight
    //   titleTop = osTitleBar.getBoundingClientRect().top
    //   if (isAte) {
    //     topPos = topPos + 10
    //   }
    // } else {
    const mainNav = document.querySelector(".main-navigation") as HTMLElement
    const metaNav = document.querySelector(".meta-navigation") as HTMLElement
    const ateMetaNav = document.getElementById("meta-bar") as HTMLElement
    const ateLogoMetaNav = document.getElementById("logo") as HTMLElement
    const ateLogoMetaNavBar = document.getElementById("nav-bar") as HTMLElement

    if (mainNav && metaNav) {
      const mainNavHeight = mainNav.offsetHeight
      const metaNavHeight = metaNav.offsetHeight
      topPos = mainNavHeight + metaNavHeight
    }
    if (isAte && ateMetaNav) {
      const top = ateMetaNav.getBoundingClientRect().top
      const metaNavTop = ateMetaNav.offsetHeight + top
      let logoNavTop = 0
      let navBarTop = 0

      if (ateLogoMetaNav) {
        const logoHeight = ateLogoMetaNav.offsetHeight
        if (logoHeight > ateMetaNav.offsetHeight) {
          logoNavTop = logoHeight + top
        }
      }
      if (ateLogoMetaNavBar) {
        const logoHeight = ateLogoMetaNavBar.offsetHeight
        navBarTop = logoHeight + ateLogoMetaNavBar.getBoundingClientRect().top
      }
      topPos = Math.max(topPos, metaNavTop, logoNavTop, navBarTop )
    }

    let anchorTop = scrollAnchor.getBoundingClientRect().top
    if (anchorTop < 0) {
      anchorTop = 0
    }
    // }
    //for testing purpose int he console
    // window.scrollY + (document.getElementById("scroll_anchor").getBoundingClientRect().top < 0 ? document.getElementById("scroll_anchor").getBoundingClientRect().top : 0) + document.getElementById("os-title-bar").getBoundingClientRect().top - document.getElementById("os-title-bar").getBoundingClientRect().height
    if (scrollAnchor) {
      let scrollAnchorTop = scrollAnchor.getBoundingClientRect().top
      scrollAnchorTop = scrollAnchorTop < 0 ? scrollAnchorTop : 0
      const scrollPos =
        window.scrollY + scrollAnchorTop + titleTop - topPos + anchorTop
      window.scrollTo({ top: scrollPos, behavior: "smooth" })
    }
    if (isOvverride) return isOnClickOvverride
    if (onClick) return onClick
    else return handleClick
  }

  return (
    <Box
      key={"box" + text}
      sx={{ display: hidden ? "none" : "initial" }}
      width={isFlexFlow ? "20%" : "50%"}
    >
      <div
        key={"div" + text}
        style={{
          textDecoration: "none",
          width: width,
          marginLeft: "auto",
          marginRight: "auto",
        }}
        onClick={checkProps()}
      >
        <StyledButton
          type={type}
          fullWidth
          variant="contained"
          sx={{ height: isFlexFlow && "32px", color: isAte && "white" }}
        >
          <Typography marginRight="10px" fontWeight="600">
            {text}
          </Typography>
          {isForwardIcon && <ArrowForwardIosIcon />}
          {isScannIcon && <QrCodeScannerIcon />}
          {isBarcode && (
            <StyledBox>
              {" "}
              <StyledImage
                height="27px"
                width="27px"
                src={barcodeIconBase64}
              />{" "}
            </StyledBox>
          )}
          {/* {isBarcode && <Image size={{width: 27, height:27}} image={barcodeIconBase64} />} */}
        </StyledButton>
      </div>
    </Box>
  )
}

export default Button
